import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { GithubCredentials } from '../types';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useGithubCredentials(tenant: number) {
  return useQuery<GithubCredentials>({
    queryKey: ['github-credentials', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/github/credentials`
      );

      return data;
    },
  });
}
